import { SET_ALERT_MESSAGE, CLEAR_ALERT_MESSAGE } from './../../actions/actionTypes';

const initialState = {
    isCustomAlertOpen: false,
    alertMessage: '',
};

const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALERT_MESSAGE:
      return { ...state, isCustomAlertOpen: true,alertMessage: action.payload };
    case CLEAR_ALERT_MESSAGE:
      return { ...state,isCustomAlertOpen: false, alertMessage: '' };
    default:
      return state;
  }
};

export default alertReducer;